/** CRM lote 4 (28/10, N1): textos do questionário no estilo do Google Formulários (`crm.quest`). */
export const questPt = {
  voltar: 'Voltar aos questionários',
  abas: { rotulo: 'Partes do questionário', perguntas: 'Perguntas', respostas: 'Respostas' },
  respostasNaLista_one: '{{count}} resposta',
  respostasNaLista_other: '{{count}} respostas',
  editadoEm: 'Editado em {{quando}}',
  abrir: 'Abrir',
  titulo: 'Título do questionário',
  tituloPadrao: 'Questionário sem título',
  descricao: 'Descrição do questionário',
  descricaoPlaceholder: 'Para que serve, quando aplicar',
  pergunta: 'Pergunta',
  perguntaPlaceholder: 'Pergunta sem título',
  descricaoPergunta: 'Descrição (opcional)',
  mostrarDescricao: 'Adicionar descrição',
  tipo: 'Tipo de pergunta',
  tipos: {
    curta: 'Resposta curta',
    paragrafo: 'Parágrafo',
    multipla: 'Múltipla escolha',
    caixas: 'Caixas de seleção',
    lista: 'Lista suspensa',
    escala: 'Escala linear',
    data: 'Data',
    hora: 'Hora',
    numero: 'Número',
  },
  secao: 'Seção',
  secaoTitulo: 'Título da seção',
  secaoPlaceholder: 'Seção sem título',
  secaoDe: 'Seção {{n}} de {{total}}',
  opcao: 'Opção {{n}}',
  opcaoRotulo: 'Texto da opção {{n}}',
  pontos: 'Pontos',
  pontosRotulo: 'Pontos da opção {{n}}',
  pontosAjuda: 'Os pontos somam a pontuação da negociação.',
  adicionarOpcao: 'Adicionar opção',
  adicionarOutro: 'adicionar "Outro"',
  ou: 'ou',
  outro: 'Outro',
  outroResposta: 'Outro: {{texto}}',
  outroPlaceholder: 'Outra resposta',
  removerOutro: 'Remover "Outro"',
  removerOpcao: 'Remover a opção {{n}}',
  subirOpcao: 'Mover a opção {{n}} para cima',
  descerOpcao: 'Mover a opção {{n}} para baixo',
  semOpcoes: 'Informe ao menos uma opção',
  opcaoRepetida: 'Opção repetida: {{opcao}}',
  escalaDe: 'De',
  escalaAte: 'até',
  rotuloMin: 'Rótulo do {{n}} (opcional)',
  rotuloMax: 'Rótulo do {{n}} (opcional)',
  respostaCurta: 'Texto de resposta curta',
  respostaLonga: 'Texto de resposta longa',
  respostaNumero: 'Número',
  respostaData: 'Dia, mês e ano',
  respostaHora: 'Hora',
  obrigatoria: 'Obrigatória',
  obrigatoriaRotulo: 'Pergunta {{n}} obrigatória',
  duplicar: 'Duplicar a pergunta {{n}}',
  excluir: 'Excluir a pergunta {{n}}',
  excluirSecao: 'Excluir a seção {{n}}',
  subir: 'Mover a pergunta {{n}} para cima',
  descer: 'Mover a pergunta {{n}} para baixo',
  adicionarPergunta: 'Adicionar pergunta',
  adicionarSecao: 'Adicionar seção',
  semPerguntas: 'Adicione ao menos uma pergunta',
  limite: 'Limite de {{n}} itens por questionário',
  salvar: 'Salvar questionário',
  descartar: 'Descartar alterações',
  alterado: 'Alterações não salvas',
  // Respostas coletadas
  respostasTotal_one: '{{count}} resposta',
  respostasTotal_other: '{{count}} respostas',
  semRespostas: 'Nenhuma resposta ainda. As respostas chegam pela aba Questionários da ficha da negociação.',
  resumo: 'Resumo',
  individuais: 'Individuais',
  visao: 'Como ver as respostas',
  exportar: 'Exportar CSV',
  arquivoCsv: 'respostas-{{nome}}.csv',
  limiteRespostas: 'Mostrando as {{n}} respostas mais recentes.',
  respondentes_one: '{{count}} resposta',
  respondentes_other: '{{count}} respostas',
  semResposta: 'Ninguém respondeu esta pergunta.',
  media: 'Média: {{valor}}',
  minMax: 'Menor: {{min}} · Maior: {{max}}',
  barra: '{{opcao}}: {{n}} ({{pct}})',
  outrasRespostas: 'Respostas em "Outro"',
  maisTextos_one: 'e mais {{count}} resposta',
  maisTextos_other: 'e mais {{count}} respostas',
  negociacao: 'Negociação',
  respondidoPor: 'Respondido por',
  respondidoEm: 'Respondido em',
  pontuacao: 'Pontuação',
  pontuacaoValor_one: '{{count}} ponto',
  pontuacaoValor_other: '{{count}} pontos',
  abrirFicha: 'Abrir a ficha da negociação {{nome}}',
  anterior: 'Resposta anterior',
  proxima: 'Próxima resposta',
  posicao: '{{n}} de {{total}}',
  semNome: 'Sem nome',
  // Ficha da negociação
  ultimaResposta: 'Respondido por {{nome}} em {{quando}}',
  ultimaRespostaSemNome: 'Respondido em {{quando}}',
  obrigatoriaAviso: '* Obrigatória',
  responda: 'Esta pergunta é obrigatória',
  invalida: 'Resposta inválida',
  limpar: 'Limpar seleção',
  escalaRotulo: '{{pergunta}}: {{n}}',
  corrigir: 'Confira as perguntas marcadas',
  // CRM lote 5 (X1): qualificação automática pela pontuação
  qualif: {
    titulo: 'Qualificação automática',
    ligar: 'Qualificar automaticamente',
    ajuda: 'Ao responder na negociação, as estrelas mudam pela faixa em que a pontuação cair. A mudança manual vale até a próxima resposta.',
    possivel: 'Pontuação possível: de {{min}} a {{max}}',
    semPontos: 'Dê pontos às opções de alguma pergunta para usar as faixas.',
    de: 'De',
    ate: 'até',
    estrelas: 'Estrelas',
    estrelasValor_one: '{{count}} estrela',
    estrelasValor_other: '{{count}} estrelas',
    faixaDe: 'Mínimo da faixa {{n}}',
    faixaAte: 'Máximo da faixa {{n}}',
    faixaEstrelas: 'Estrelas da faixa {{n}}',
    adicionar: 'Adicionar faixa',
    remover: 'Remover a faixa {{n}}',
    limite: 'Limite de {{n}} faixas',
    erroSemFaixas: 'Informe ao menos uma faixa de pontuação',
    erroNumero: 'Informe o mínimo e o máximo da faixa',
    erroInvertida: 'O mínimo passa do máximo',
    erroFora: 'Fora da pontuação possível (de {{min}} a {{max}})',
    erroSobreposta: 'Faixa sobreposta a outra',
  },
};

export type DicQuest = typeof questPt;

export const questEn: DicQuest = {
  voltar: 'Back to questionnaires',
  abas: { rotulo: 'Questionnaire parts', perguntas: 'Questions', respostas: 'Responses' },
  respostasNaLista_one: '{{count}} response',
  respostasNaLista_other: '{{count}} responses',
  editadoEm: 'Edited on {{quando}}',
  abrir: 'Open',
  titulo: 'Questionnaire title',
  tituloPadrao: 'Untitled questionnaire',
  descricao: 'Questionnaire description',
  descricaoPlaceholder: 'What it is for, when to use it',
  pergunta: 'Question',
  perguntaPlaceholder: 'Untitled question',
  descricaoPergunta: 'Description (optional)',
  mostrarDescricao: 'Add description',
  tipo: 'Question type',
  tipos: {
    curta: 'Short answer',
    paragrafo: 'Paragraph',
    multipla: 'Multiple choice',
    caixas: 'Checkboxes',
    lista: 'Dropdown',
    escala: 'Linear scale',
    data: 'Date',
    hora: 'Time',
    numero: 'Number',
  },
  secao: 'Section',
  secaoTitulo: 'Section title',
  secaoPlaceholder: 'Untitled section',
  secaoDe: 'Section {{n}} of {{total}}',
  opcao: 'Option {{n}}',
  opcaoRotulo: 'Text of option {{n}}',
  pontos: 'Points',
  pontosRotulo: 'Points of option {{n}}',
  pontosAjuda: 'Points add up to the deal score.',
  adicionarOpcao: 'Add option',
  adicionarOutro: 'add "Other"',
  ou: 'or',
  outro: 'Other',
  outroResposta: 'Other: {{texto}}',
  outroPlaceholder: 'Other answer',
  removerOutro: 'Remove "Other"',
  removerOpcao: 'Remove option {{n}}',
  subirOpcao: 'Move option {{n}} up',
  descerOpcao: 'Move option {{n}} down',
  semOpcoes: 'Enter at least one option',
  opcaoRepetida: 'Repeated option: {{opcao}}',
  escalaDe: 'From',
  escalaAte: 'to',
  rotuloMin: 'Label for {{n}} (optional)',
  rotuloMax: 'Label for {{n}} (optional)',
  respostaCurta: 'Short answer text',
  respostaLonga: 'Long answer text',
  respostaNumero: 'Number',
  respostaData: 'Day, month and year',
  respostaHora: 'Time',
  obrigatoria: 'Required',
  obrigatoriaRotulo: 'Question {{n}} required',
  duplicar: 'Duplicate question {{n}}',
  excluir: 'Delete question {{n}}',
  excluirSecao: 'Delete section {{n}}',
  subir: 'Move question {{n}} up',
  descer: 'Move question {{n}} down',
  adicionarPergunta: 'Add question',
  adicionarSecao: 'Add section',
  semPerguntas: 'Add at least one question',
  limite: 'Limit of {{n}} items per questionnaire',
  salvar: 'Save questionnaire',
  descartar: 'Discard changes',
  alterado: 'Unsaved changes',
  respostasTotal_one: '{{count}} response',
  respostasTotal_other: '{{count}} responses',
  semRespostas: 'No responses yet. Responses come from the Questionnaires tab of the deal page.',
  resumo: 'Summary',
  individuais: 'Individual',
  visao: 'How to view the responses',
  exportar: 'Export CSV',
  arquivoCsv: 'responses-{{nome}}.csv',
  limiteRespostas: 'Showing the {{n}} most recent responses.',
  respondentes_one: '{{count}} response',
  respondentes_other: '{{count}} responses',
  semResposta: 'No one answered this question.',
  media: 'Average: {{valor}}',
  minMax: 'Lowest: {{min}} · Highest: {{max}}',
  barra: '{{opcao}}: {{n}} ({{pct}})',
  outrasRespostas: '"Other" answers',
  maisTextos_one: 'and {{count}} more response',
  maisTextos_other: 'and {{count}} more responses',
  negociacao: 'Deal',
  respondidoPor: 'Answered by',
  respondidoEm: 'Answered on',
  pontuacao: 'Score',
  pontuacaoValor_one: '{{count}} point',
  pontuacaoValor_other: '{{count}} points',
  abrirFicha: 'Open the deal page {{nome}}',
  anterior: 'Previous response',
  proxima: 'Next response',
  posicao: '{{n}} of {{total}}',
  semNome: 'No name',
  ultimaResposta: 'Answered by {{nome}} on {{quando}}',
  ultimaRespostaSemNome: 'Answered on {{quando}}',
  obrigatoriaAviso: '* Required',
  responda: 'This question is required',
  invalida: 'Invalid answer',
  limpar: 'Clear selection',
  escalaRotulo: '{{pergunta}}: {{n}}',
  corrigir: 'Check the highlighted questions',
  // CRM batch 5 (X1): automatic qualification by score
  qualif: {
    titulo: 'Automatic qualification',
    ligar: 'Qualify automatically',
    ajuda: 'When answered in the deal, the stars change by the range the score falls in. A manual change holds until the next answer.',
    possivel: 'Possible score: from {{min}} to {{max}}',
    semPontos: 'Give points to the options of some question to use the ranges.',
    de: 'From',
    ate: 'to',
    estrelas: 'Stars',
    estrelasValor_one: '{{count}} star',
    estrelasValor_other: '{{count}} stars',
    faixaDe: 'Minimum of range {{n}}',
    faixaAte: 'Maximum of range {{n}}',
    faixaEstrelas: 'Stars of range {{n}}',
    adicionar: 'Add range',
    remover: 'Remove range {{n}}',
    limite: 'Limit of {{n}} ranges',
    erroSemFaixas: 'Enter at least one score range',
    erroNumero: 'Enter the minimum and the maximum of the range',
    erroInvertida: 'The minimum is above the maximum',
    erroFora: 'Outside the possible score (from {{min}} to {{max}})',
    erroSobreposta: 'Range overlaps another',
  },
};

export const questEs: DicQuest = {
  voltar: 'Volver a los cuestionarios',
  abas: { rotulo: 'Partes del cuestionario', perguntas: 'Preguntas', respostas: 'Respuestas' },
  respostasNaLista_one: '{{count}} respuesta',
  respostasNaLista_other: '{{count}} respuestas',
  editadoEm: 'Editado el {{quando}}',
  abrir: 'Abrir',
  titulo: 'Título del cuestionario',
  tituloPadrao: 'Cuestionario sin título',
  descricao: 'Descripción del cuestionario',
  descricaoPlaceholder: 'Para qué sirve, cuándo aplicarlo',
  pergunta: 'Pregunta',
  perguntaPlaceholder: 'Pregunta sin título',
  descricaoPergunta: 'Descripción (opcional)',
  mostrarDescricao: 'Agregar descripción',
  tipo: 'Tipo de pregunta',
  tipos: {
    curta: 'Respuesta corta',
    paragrafo: 'Párrafo',
    multipla: 'Opción múltiple',
    caixas: 'Casillas de verificación',
    lista: 'Desplegable',
    escala: 'Escala lineal',
    data: 'Fecha',
    hora: 'Hora',
    numero: 'Número',
  },
  secao: 'Sección',
  secaoTitulo: 'Título de la sección',
  secaoPlaceholder: 'Sección sin título',
  secaoDe: 'Sección {{n}} de {{total}}',
  opcao: 'Opción {{n}}',
  opcaoRotulo: 'Texto de la opción {{n}}',
  pontos: 'Puntos',
  pontosRotulo: 'Puntos de la opción {{n}}',
  pontosAjuda: 'Los puntos suman la puntuación de la negociación.',
  adicionarOpcao: 'Agregar opción',
  adicionarOutro: 'agregar "Otro"',
  ou: 'o',
  outro: 'Otro',
  outroResposta: 'Otro: {{texto}}',
  outroPlaceholder: 'Otra respuesta',
  removerOutro: 'Quitar "Otro"',
  removerOpcao: 'Quitar la opción {{n}}',
  subirOpcao: 'Subir la opción {{n}}',
  descerOpcao: 'Bajar la opción {{n}}',
  semOpcoes: 'Informa al menos una opción',
  opcaoRepetida: 'Opción repetida: {{opcao}}',
  escalaDe: 'De',
  escalaAte: 'a',
  rotuloMin: 'Etiqueta del {{n}} (opcional)',
  rotuloMax: 'Etiqueta del {{n}} (opcional)',
  respostaCurta: 'Texto de respuesta corta',
  respostaLonga: 'Texto de respuesta larga',
  respostaNumero: 'Número',
  respostaData: 'Día, mes y año',
  respostaHora: 'Hora',
  obrigatoria: 'Obligatoria',
  obrigatoriaRotulo: 'Pregunta {{n}} obligatoria',
  duplicar: 'Duplicar la pregunta {{n}}',
  excluir: 'Eliminar la pregunta {{n}}',
  excluirSecao: 'Eliminar la sección {{n}}',
  subir: 'Subir la pregunta {{n}}',
  descer: 'Bajar la pregunta {{n}}',
  adicionarPergunta: 'Agregar pregunta',
  adicionarSecao: 'Agregar sección',
  semPerguntas: 'Agrega al menos una pregunta',
  limite: 'Límite de {{n}} elementos por cuestionario',
  salvar: 'Guardar cuestionario',
  descartar: 'Descartar cambios',
  alterado: 'Cambios sin guardar',
  respostasTotal_one: '{{count}} respuesta',
  respostasTotal_other: '{{count}} respuestas',
  semRespostas: 'Aún no hay respuestas. Llegan desde la pestaña Cuestionarios de la ficha de la negociación.',
  resumo: 'Resumen',
  individuais: 'Individuales',
  visao: 'Cómo ver las respuestas',
  exportar: 'Exportar CSV',
  arquivoCsv: 'respuestas-{{nome}}.csv',
  limiteRespostas: 'Se muestran las {{n}} respuestas más recientes.',
  respondentes_one: '{{count}} respuesta',
  respondentes_other: '{{count}} respuestas',
  semResposta: 'Nadie respondió esta pregunta.',
  media: 'Promedio: {{valor}}',
  minMax: 'Menor: {{min}} · Mayor: {{max}}',
  barra: '{{opcao}}: {{n}} ({{pct}})',
  outrasRespostas: 'Respuestas en "Otro"',
  maisTextos_one: 'y {{count}} respuesta más',
  maisTextos_other: 'y {{count}} respuestas más',
  negociacao: 'Negociación',
  respondidoPor: 'Respondido por',
  respondidoEm: 'Respondido el',
  pontuacao: 'Puntuación',
  pontuacaoValor_one: '{{count}} punto',
  pontuacaoValor_other: '{{count}} puntos',
  abrirFicha: 'Abrir la ficha de la negociación {{nome}}',
  anterior: 'Respuesta anterior',
  proxima: 'Respuesta siguiente',
  posicao: '{{n}} de {{total}}',
  semNome: 'Sin nombre',
  ultimaResposta: 'Respondido por {{nome}} el {{quando}}',
  ultimaRespostaSemNome: 'Respondido el {{quando}}',
  obrigatoriaAviso: '* Obligatoria',
  responda: 'Esta pregunta es obligatoria',
  invalida: 'Respuesta inválida',
  limpar: 'Borrar selección',
  escalaRotulo: '{{pergunta}}: {{n}}',
  corrigir: 'Revisa las preguntas marcadas',
  // CRM lote 5 (X1): calificación automática por la puntuación
  qualif: {
    titulo: 'Calificación automática',
    ligar: 'Calificar automáticamente',
    ajuda: 'Al responder en la negociación, las estrellas cambian según el rango en que caiga la puntuación. El cambio manual vale hasta la próxima respuesta.',
    possivel: 'Puntuación posible: de {{min}} a {{max}}',
    semPontos: 'Da puntos a las opciones de alguna pregunta para usar los rangos.',
    de: 'De',
    ate: 'a',
    estrelas: 'Estrellas',
    estrelasValor_one: '{{count}} estrella',
    estrelasValor_other: '{{count}} estrellas',
    faixaDe: 'Mínimo del rango {{n}}',
    faixaAte: 'Máximo del rango {{n}}',
    faixaEstrelas: 'Estrellas del rango {{n}}',
    adicionar: 'Agregar rango',
    remover: 'Quitar el rango {{n}}',
    limite: 'Límite de {{n}} rangos',
    erroSemFaixas: 'Indica al menos un rango de puntuación',
    erroNumero: 'Indica el mínimo y el máximo del rango',
    erroInvertida: 'El mínimo supera al máximo',
    erroFora: 'Fuera de la puntuación posible (de {{min}} a {{max}})',
    erroSobreposta: 'Rango superpuesto a otro',
  },
};
